module.exports = __webpack_public_path__ + "videos/schuette-welcome-video-3.f7da539.mp4";